/* eslint-disable */
<template>
  <div id="mainGraphPane">
    <button id="nodeOperationBtn" data-bs-toggle="modal" data-bs-target="#nodeOperation" style="display: none">Click Me</button>
    <vue-loaders-ball-beat v-if="isLoading"></vue-loaders-ball-beat>
    <div id="mountNode" ref='mountNode' ></div>
  </div>
</template>

<script>
import G6 from '@antv/g6';
import graphConfig from '../plugins/graphConfig';
// import DendroGramComp from './DendroGramComp.vue';

export default {
  metaInfo: {
    title: 'Graphs',
  },
  components: {
    // DendroGramComp,
  },
  data() {
    return {
      isLoading: false,
      toggleGraph: true,
      searchWord: '',
    };
  },

  watch: {
    explore_data(val) {
      this.full_graph.changeData(val);
    },
    edit_mode(val) {
      if (val === 'hsl') {
        this.full_graph.setMode('hsl');
      } else {
        this.full_graph.setMode('default');
      }
    },
  },

  async mounted() {
    // await this.wikiGraphBuild('Naruto');
    await this.wikiGraphBuild();
  },
  async created() {
    await this.$highway.singleDispatcher('gmodule/exploreGraphFetch');
    // console.log('G6 Explore Mounted');
    this.$root.$on('graph-save', (payload) => {
      // console.log('graph-save', payload);
      this.saveCurrentGraph(payload);
    });
  },
  beforeDestroy() {
    this.$root.$off('graph-save');
  },
  methods: {
    clearStates() {
      this.full_graph.getNodes().forEach((node) => {
        this.full_graph.clearItemStates(node);
      });
      this.full_graph.getEdges().forEach((edge) => {
        this.full_graph.clearItemStates(edge);
      });
    },
    updateMyNode(val) {
      // console.log('Emitted Node val', val);
      const updatedNode = this.full_graph.findById(val.id);
      updatedNode.update(val);
    },
    async wikiGraphBuild() {
      // plugins
      const minimap = new G6.Minimap({
        size: [50, 50],
        className: 'minimap',
        type: 'delegate',
      });
      // highlight plugins
      const tooltip = new G6.Tooltip({
        offsetX: 10,
        offsetY: 10,
        fixToNode: [1, 0.5],
        // the types of items that allow the tooltip show up
        // 允许出现 tooltip 的 item 类型
        itemTypes: ['node', 'edge'],
        // custom the tooltip's content
        // 自定义 tooltip 内容
        getContent: (e) => {
          const outDiv = document.createElement('div');
          outDiv.style.width = 'fit-content';
          outDiv.style.height = 'fit-content';
          const model = e.item.getModel();
          if (e.item.getType() === 'node') {
            outDiv.innerHTML = `${model.label}`;
          } else {
            const source = e.item.getSource();
            const target = e.item.getTarget();
            outDiv.innerHTML = `source: ${source.getModel().label}<br/>target: ${target.getModel().label}`;
          }
          return outDiv;
        },
      });
      this.gdata = this.$store.state.gmodule.g6_explore_data;
      this.config = graphConfig;
      this.config.container = this.$refs.mountNode;
      this.config.plugins = [minimap, tooltip];
      this.full_graph = new G6.Graph(this.config);

      await this.$store.dispatch('gmodule/getGraph', this.$route.params.id);
      // const response = await axios.get('https://api.jsonbin.io/b/61bd99e1a4e2423c2b07eadb');
      this.full_graph.data(this.gdata);
      this.full_graph.render();

      if (typeof window !== 'undefined') {
        window.onresize = () => {
          const myCanvas = this.$refs.mountNode;
          // console.log(myCanvas.clientWidth);
          // console.log(myCanvas.clientHeight);
          // if (!this.full_graph || this.full_graph.get('destroyed')) return;
          // if (!container || !container.scrollWidth || !container.scrollHeight) return;
          this.full_graph.changeSize(myCanvas.clientWidth, 708);
          // this.full_graph.fitCenter();
        };
      }
    },
  },
};
</script>

<style scoped>
  div {
    font-family: 'Helvetica', sans-serif;
  }
  #mainGraphPane {
    background: #576f7f;
  }
  /* .g6-component-tooltip {
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    font-size: 0.75rem;
    color: #000;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px 8px;
    box-shadow: rgb(174, 174, 174) 0px 0px 10px;
  } */
</style>
